import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
// components
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import { MembershipTag } from 'components/Tag'
import Step from 'components/Step'
import { CreditIllus } from 'assets/icons'

// others
import { CREDIT_LINE_VALIDITY_DAYS } from 'constants/credit'

const STEPS = [
  {
    number: 1,
    description: 'Elegí cuánto y cómo querés devolverlo.'
  },
  {
    number: 2,
    description: 'Recibí el dinero de inmediato en tu billetera.'
  },
  {
    number: 3,
    description: 'Podés comprar lo que quieras usando tu tarjeta Wayni.'
  }
]

interface FirstTimeInAdvanceSectionProps {
  setHasVisited: (s: boolean) => void
  isOpen: boolean
}

const FirstTimeInAdvanceSection = ({
  setHasVisited,
  isOpen
}: FirstTimeInAdvanceSectionProps) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_informativo_adelantos' })
  }, [])

  return (
    <ModalContainer
      className='!max-w-[25rem] !p-0'
      isShown={isOpen}
      noCloseButton
      setModalFunction={() => setHasVisited(true)}
    >
      <div className='rounded-t-lg px-4 bg-advance-modal w-full'>
        <CreditIllus className='mx-auto pt-2' />
      </div>

      <div className='px-4 bg-gray-100'>
        <h2 className='text-center text-black font-bold text-xl leading-5'>
          Probá Wayni Adelantos: <br />
          ¡Dinero al instante!
        </h2>
        <MembershipTag text='Exclusivo Wayni+' className='mx-auto mt-2' />

        <div className='space-y-4 my-4 self-start'>
          {STEPS.map((item, idx) => (
            <Step key={idx} step={item} />
          ))}
        </div>

        <p className='font-medium text-2xs text-gray-900 pt-2 leading-3'>
          * Mantenemos tu línea de crédito por {CREDIT_LINE_VALIDITY_DAYS} días
          corridos. Si se vencen, no te preocupes, podés volver a solicitar.
        </p>

        <PrimaryButton
          buttonText='¡Empezar!'
          primaryButtonFunction={() => setHasVisited(true)}
          className='md:max-w-[18.5rem] max-w-full mx-auto mb-4 mt-8 md:mt-4'
        />
      </div>
    </ModalContainer>
  )
}

export default FirstTimeInAdvanceSection
